import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { io } from "socket.io-client";
import { BASE_URL } from "../../api/config";

const ChatPresenceContext = createContext(null);

export const useChatPresence = () => {
  const ctx = useContext(ChatPresenceContext);
  if (!ctx) {
    return {
      socketRef: { current: null },
      isConnected: false,
    };
  }
  return ctx;
};

export const ChatPresenceProvider = ({ children }) => {
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("user");
    if (!token) return;

    const url = BASE_URL.replace(/\/api\/.*$/, "");

    const socket = io(url + "/chat", {
      query: { token },
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });

    socketRef.current = socket;

    socket.on("connect", () => {
      setIsConnected(true);
    });

    socket.on("disconnect", (reason) => {
      setIsConnected(false);
    });

    socket.on("connect_error", (err) => {
      console.error("[ChatPresence] Connection error:", err.message);
      setIsConnected(false);
    });

    /* ── Bridge socket events → CustomEvents ── */
    socket.on("chat_stream_start", (data) => {
      window.dispatchEvent(
        new CustomEvent("chat:stream-start", { detail: data }),
      );
    });

    socket.on("chat_stream_chunk", (data) => {
      window.dispatchEvent(
        new CustomEvent("chat:stream-chunk", { detail: data }),
      );
    });

    socket.on("chat_stream_end", (data) => {
      window.dispatchEvent(
        new CustomEvent("chat:stream-end", { detail: data }),
      );
    });

    socket.on("chat_stream_cancelled", (data) => {
      window.dispatchEvent(
        new CustomEvent("chat:stream-cancelled", { detail: data }),
      );
    });

    socket.on("error", (data) => {
      console.error("[ChatPresence] Server error:", data.message);
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, []);

  const value = {
    socketRef,
    isConnected,
  };

  return (
    <ChatPresenceContext.Provider value={value}>
      {children}
    </ChatPresenceContext.Provider>
  );
};

export default ChatPresenceContext;
